import React, { Component } from 'react';
import { connect } from "react-redux";
import SequencerToolbar from 'components/toolbar/SequencerToolbar.js';
import AudioInputChooser from 'components/AudioInputChooser.js';
import SampleRateChooser from './preferences/SampleRateChooser.js';
import ClockOptions from './ClockOptions.js';
import SubPageHeader from 'components/SubPageHeader.js';
import {setViewMode} from 'actions/index.js';
import {setDecentralized} from 'actions/index.js';
import {setLatency} from 'actions/index.js';
import {SEQUENCER_VIEW} from 'constants/view-modes.js';
import {isNumber} from 'utils/IsNumber.js';
import {KEYBOARD, PADS} from 'midi/constants.js';
import {NONE, MASTER, SLAVE} from 'constants/clock-types.js';
import Dropdown from 'react-dropdown'
import '../Preferences.css';

class PreferencesView extends Component {

    constructor(props) {
        super(props);
        this.state = {};
        console.log(props.midiEngine);
    }

    componentWillUnmount() {
        this.props.sequencerEngine.clockSync.stopListening();
    }

    onLatencyChanged(e) {
        if (isNumber(e)) {
            this.props.setLatency(e);
        }
    
    }

    async componentDidMount() {
        console.log('preferences component did mount');
        this.props.sequencerEngine.clockSync.startListening();
        await this.props.midiEngine.loadAvailableDevices();
        this.props.sequencerEngine.channelMixer.updateChannelCount();
        this.setState(this.state);
    }

    syncChanged() {
        this.setState(this.state);
    }

    isMultiChannelRecording() {
        return !this.props.channelMixer.stereoConnected;
    }

    switchOutputs(isMulti) {
        this.props.channelMixer.switchOutputs(isMulti);
        this.setState(this.state);
    }

    onChooseAudio(stream, deviceId) {
        this.props.sequencerEngine.audioInputManager.newInputSource(stream, deviceId);
        this.setState(this.state);
    }

    render() {
        return (
            <div className="preferences-view">
              <SubPageHeader headerText="Preferences" onClickBack={() => this.props.setViewMode(SEQUENCER_VIEW)}/>
                <div className="preferences-flex">
                  <div className="midi-preferences panel">
                    <div className="midi-preferences-subsection">
                    <div className="sub-header">MIDI</div>
                    <div className="inputs-heading">INPUTS</div>
                    {this.props.midiEngine.getInputs().map(
                        input =>
                        <MidiInput syncChanged={() => this.syncChanged()} input={input} midiEngine={this.props.midiEngine}/>)}
                    </div>
                    <div className="midi-preferences-subsection">
                <div className="outputs-heading">OUTPUTS</div>
                {this.props.midiEngine.getOutputs().map(
                    output =>
                        <MidiOutput output={output} midiEngine={this.props.midiEngine}/>)}
            </div>
            </div>
                <div className="audio-preferences panel">
                <div className="sub-header">AUDIO</div>
                  <SampleRateChooser
                    sequencerEngine={this.props.sequencerEngine}
                  />
                <AudioInputChooser
            deviceId={this.props.sequencerEngine.audioInputManager.deviceId}
            defaultClassName="preferences-audio-chooser" onChooseAudio={(stream, deviceId) => this.onChooseAudio(stream, deviceId)}/>
                <MultiChannelButton
            isMultiChannelOutput={this.isMultiChannelRecording()}
            numberOfChannels={this.props.channelMixer.numberOfChannels()}
            onClick={(isMultiChannel) => this.switchOutputs(isMultiChannel)} />
                <div className="latency-container">
                <div>Latency (ms)</div>
                       <input                  
                         className="chord-input"
                         onChange={e => this.onLatencyChanged(e.target.value)}
                         value={this.props.latency}
                         placeholder="Latency" className='tags-input' type="text"/>
                </div>
                <ClockOptions sequencerEngine={this.props.sequencerEngine}/>
               </div>
                </div>
                </div>
        );
    }
}

class MidiInput extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onClickSynced() {
        if (!this.props.midiEngine.isInputSynced(this.props.input)) {
            this.props.midiEngine.syncInput(this.props.input);
        } else {
            console.log('unsyncing ' + this.props.input);
            this.props.midiEngine.unsyncInput(this.props.input);
        }
        
        this.props.syncChanged();
        this.setState(this.state);
    }

    onClickTracked() {
        if (!this.props.midiEngine.isInputTracked(this.props.input)) {
            this.props.midiEngine.trackInput(this.props.input);
        } else {
            this.props.midiEngine.untrackInput(this.props.input);
        }
        this.setState(this.state);
    }

    onClickKeys() {
        this.props.midiEngine.setInputMode(this.props.input, KEYBOARD);
        this.setState(this.state);
    }

    onClickPads() {
        this.props.midiEngine.setInputMode(this.props.input, PADS);
        this.setState(this.state);
    }

    render() {
        let synced = this.props.midiEngine.isInputSynced(this.props.input);
        let tracked = this.props.midiEngine.isInputTracked(this.props.input);
        let mode = this.props.midiEngine.getInputMode(this.props.input.name);
        console.log('tracked = ' + tracked);
        return (
            <div className="midi-input">
              <div className="midi-name">{this.props.input.name}</div>
              <div className="midi-options">
              <div
                onClick={() => this.onClickTracked()}
                className={tracked ? "midi-option enabled" : "midi-option"}>
                TRACK
              </div>
              <div
                onClick={() => this.onClickSynced()}
                className={synced ? "midi-option enabled" : "midi-option"}>
                SYNC
              </div>
              <div
                onClick={() => this.onClickKeys()}
                className={mode === KEYBOARD ? "midi-option enabled" : "midi-option"}>
                KEYS
              </div>
               <div
                onClick={() => this.onClickPads()}
                className={mode == PADS ? "midi-option enabled" : "midi-option"}>
                 PADS 
              </div>
              </div>
 
            </div>
        );
    }
}

class MidiOutput extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onClickSync() {
        console.log('onClickSync called with props otput = ');
        console.log(this.props.output);
        this.props.midiEngine.syncOutput(this.props.output);
        this.setState(this.state);
    }

    onClickTracked() {
        if (!this.props.midiEngine.isOutputTracked(this.props.output)) {
            this.props.midiEngine.trackOutput(this.props.output);
        } else {
            this.props.midiEngine.untrackOutput(this.props.output);
        }
        this.setState(this.state);
    }

    render() {
        let tracked = this.props.midiEngine.isOutputTracked(this.props.output);
        let synced = this.props.midiEngine.systemOutput === this.props.output;
        return (
            <div className="midi-output">
              <div className="midi-name">{this.props.output.name}</div>
              <div className="midi-options">
              <div
                onClick={() => this.onClickTracked()}
                className={tracked ? "midi-option enabled" : "midi-option"}>
                TRACK
              </div>
              <div
                onClick={() => this.onClickSync()}
                className={synced ? "midi-option enabled" : "midi-option"}>SYNC</div>
              </div>
            </div>
        );
    }
}

class DecentralizedButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onClick() {
        this.props.onClick(!this.props.decentralized);
        this.setState(this.state);
    }

    render() {
        return (
            <div onClick={() => this.onClick()} className="decentralized-option">
              {this.props.decentralized ? 'DECENTRALIZED' : 'CENTRALIZED'}
            </div>
        );
    }
}

class MultiChannelButton extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onClick() {
        this.props.onClick(!this.props.decentralized);
        this.setState(this.state);
    }

    render() {
        return (
            <div onClick={() => this.props.onClick(!this.props.isMultiChannelOutput)} className="audio-outputs-option">
              {this.props.isMultiChannelOutput ? 'MULTI CHANNEL OUTPUT ' : 'SINGLE OUTPUT '}
                ({this.props.numberOfChannels} channels)
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setViewMode: viewMode => dispatch(setViewMode(viewMode)),
        setDecentralized: decentralized => dispatch(setDecentralized(decentralized)),
        setLatency: latency => dispatch(setLatency(latency)),
    }
};

const mapStateToProps = state => {
    return {
        decentralized: state.sequencer.decentralized,
        latency: state.sequencer.latency,
    };
};



export default connect(mapStateToProps, mapDispatchToProps)(PreferencesView);
